module.exports = __webpack_public_path__ + "static/img/pcbg.26dce35.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pcbg.jpeg
// module id = Cgx2
// module chunks = 2